import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon, Text } from '@siteground/styleguide';
import { MESSAGE_TYPES } from '../../../../src/shared/constants';
import { setChatMinimized } from '../../app-communication/actions/from-client-frontend';
import { getChatSettings } from '../../selectors/chat';
import { getChatMessages } from '../../selectors/messages';
import './minimized-state.css';

const MinimizedState = () => {
  const { minimized } = useSelector(getChatSettings);
  const messages = useSelector(getChatMessages);
  const prevMessages = React.useRef(messages);
  const prevMessagesToCount = prevMessages.current.filter((message) => message.messageType !== MESSAGE_TYPES.FROM_USER);
  const currentMessagesToCount = messages.filter((message) => message.messageType !== MESSAGE_TYPES.FROM_USER);
  const newMessages = currentMessagesToCount.length - prevMessagesToCount.length;
  const dispatch = useDispatch();

  return (
    <div className="chat-close-state" onClick={() => dispatch(setChatMinimized(!minimized))}>
      {newMessages > 0 && (
        <div className="chat-close-state__unread-messages">
          <Text className="chat-close-state__unread-messages-text" weight="bold">
            {newMessages > 9 ? '9+' : newMessages}
          </Text>
        </div>
      )}
      <Icon name="chat-icon" size="24" color="white" data-minimized-icon />
    </div>
  );
};

export default MinimizedState;
